module.exports = __webpack_public_path__ + "static/media/cooking-oil-being-poured-into-a-bowl.8156cb19.jpg";